import { searchObjectsOnFields } from '@/utils/search';
import { useCallback, useMemo } from 'react';

type Props<T> = {
  data: T[];
  query: string;
  searchableFields: string[];
};

export const useClientSideSearch = <T extends object>({ data, query, searchableFields }: Props<T>) => {
  const getFilteredData = useCallback(
    (data: T[]) => {
      if (!query || searchableFields.length === 0) {
        return data;
      }
      return searchObjectsOnFields(query, data, searchableFields);
    },
    [query, searchableFields],
  );

  const filteredData = useMemo(() => getFilteredData(data), [data, getFilteredData]);

  return {
    filteredData,
  };
};
